customElements.whenDefined('search-form').then(() => {
  class MainSearch extends SearchForm {
    constructor() {
      super();
      this.allSearchInputs = document.querySelectorAll('input[type="search"]');
      this.setupEventListeners();
      this.setupPredictiveSearchOrdering();
    }

    setupEventListeners() {
      let allSearchForms = [];
      this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      if (allSearchForms.length < 2) return;
      allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
      this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
    }

    setupPredictiveSearchOrdering() {
      const searchTerm = this.input.value.trim();
      const searchSection = this.closest('.template-search');
      const gridContainer = searchSection?.querySelector('#ProductGridContainer');
      const form = document.querySelector('.predictive_search_page_form');
      if (!searchTerm || !gridContainer || !form) return;
      const params = new URLSearchParams(new FormData(form));
      const searchParams = new URLSearchParams(window.location.search);
      const productType = searchParams.get('filter.p.product_type');
      params.set('q', productType ? 'product_type:' + productType + ' AND ' + searchTerm : searchTerm);

      const productPath = (href) => {
        try {
          const url = new URL(href, window.location.origin);
          return url.origin === window.location.origin ? url.pathname.replace(/\/+$/, '') : '';
        } catch { return ''; }
      };
      const suggestions = fetch(routes.predictive_search_url + '?' + params.toString())
        .then((response) => response.ok ? response.text() : '')
        .then((markup) => {
          const doc = new DOMParser().parseFromString(markup, 'text/html');
          return Array.from(doc.querySelectorAll('#predictive-search-results-products-list a[href]'))
            .map((link) => productPath(link.getAttribute('href'))).filter(Boolean);
        }).catch(() => []);

      let frameScheduled = false;
      const reorder = async () => {
        const sortBy = new URLSearchParams(window.location.search).get('sort_by');
        if (sortBy && sortBy !== 'relevance') return;
        const grid = gridContainer.querySelector('ul.product-grid');
        if (!grid) return;
        const paths = await suggestions;
        if (!paths.length) return;
        const rank = new Map(paths.map((path, index) => [path, index]));
        const items = Array.from(grid.children).filter((item) => item.matches('li.js-pagination__item'));
        const order = new Map(items.map((item, index) => [item, index]));
        const itemPath = (item) => productPath(item.querySelector('a[href*="/products/"]')?.getAttribute('href') || '');
        const sorted = items.slice().sort((a, b) =>
          (rank.get(itemPath(a)) ?? Number.MAX_SAFE_INTEGER) - (rank.get(itemPath(b)) ?? Number.MAX_SAFE_INTEGER) || order.get(a) - order.get(b)
        );
        if (!sorted.every((item, index) => item === items[index])) sorted.forEach((item) => grid.appendChild(item));
      };
      const schedule = () => {
        if (frameScheduled) return;
        frameScheduled = true;
        window.requestAnimationFrame(() => { frameScheduled = false; reorder(); });
      };
      new MutationObserver(schedule).observe(gridContainer, { childList: true, subtree: true });
      reorder();
    }

    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) this.keepInSync('', this.input);
    }
    onInput(event) {
      const target = event.target;
      this.keepInSync(target.value, target);
    }
    onInputFocus() {
      if (window.innerWidth < 750) this.scrollIntoView({behavior: 'smooth'});
    }
    keepInSync(value, target) {
      this.allSearchInputs.forEach((input) => { if (input !== target) input.value = value; });
    }
  }
  customElements.define('main-search', MainSearch);
});